import {mapGetters} from "vuex";

const PaymentCapacityTypes = {
    all : 'All Payments',
    full : 'Full Payment',
    partial : 'Partial Payment'
}

export default {
  name: "widgetHelper",
  props: {
    settings: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      scrollAllow: false,
    }
  },
  computed: {
    ...mapGetters(["collectives"]),

    boardType() {
      const board = this.$store.state.boards.active ? this.$store.state.boards.boards[this.$store.state.boards.active] : null;
      return board?.type || '';
    },

    target_type() {
      return this.settings.value.target_type;
    },

    currency() {
      return this.target_type === 'Amount' ? '$' : '';
    },

    selectedCollectives() {
      const streamCollectives = this?.streams?.streams?.statistic?.collectives || [];
      const selected_collectives = this.settings.value.selected_collectives;
      let collectives = selected_collectives.map((id) => {
          const elem = streamCollectives.find(el => el.id === id);
          if (elem) {
              return {
                  ...elem,
                  logo: this?.collectives?.[elem.id]?.logo || null
              };
          } else {
              return false;
          }
      });
      return collectives.filter(el => el) || [];
  },

    selectedShifts() {
      const streamShifts = this?.streams?.streams?.statistic?.shifts || [];
      const selected_shifts = this.settings.value.selected_shifts;
      let shifts = selected_shifts.map((id) => {
        const elem = streamShifts.find(el => el.id === id);
        if (elem) {
          return elem;
        } else {
          return false;
        }
      });
      return shifts.filter(el => el) || [];
    },

    selectedRoles() {
      const streamRoles = this?.streams?.streams?.statistic?.roles || [];
      const selected_roles = this.settings.value.selected_roles;
      let roles = selected_roles.map((id) => {
        const elem = streamRoles.find(el => el.id === id);
        if (elem) {
          return elem;
        } else {
          return false;
        }
      });

      return roles.filter(el => el) || [];
    },

    selectedUsers() {
        const streamUsers = this?.streams?.streams?.statistic?.users || [];
        const selected_agents = this.settings.value.selected_agents;
        let users = selected_agents.map((id) => {
            const elem = streamUsers.find(el => el.id === id);
            if (elem) {
                return elem;
            } else {
                return false;
            }
        });

        return users.filter(el => el) || [];
    },

    selectedAgents() {
      const streams = this?.streams?.streams;
      if (!streams) { return []; }
      const streamAgents = streams.statistic.users || [];

      const need = {
        agents: this.settings.value.selected_agents || [],
        roles: this.settings.value.selected_roles || [],
        shifts: this.settings.value.selected_shifts || [],
        collectives: this.settings.value.selected_collectives || []
      }

      let agents = need.agents.map((id) => {
        const elem = streamAgents.find(el => el.id === id);
        if (elem) {
          return elem;
        } else {
          return false;
        }
      });

      agents = agents.filter(el => el);

      for (const role_id of need.roles) {
        let list = [];
        for (let agent of streamAgents) {
          if (agent.role === role_id) {
            if (!agents.find(el => el.id === agent.id)) {
              list.push(agent);
            }
          }
        }
        if (list.length) {
          agents = [...agents, ...list];
        }
      }

      for (const shift_id of need.shifts) {
        let list = [];
        for (let agent of streamAgents) {
          if (Array.isArray(agent.shifts)) {
            if (agent.shifts.find(shft => shft === shift_id)) {
              if (!agents.find(el => el.id === agent.id)) {
                list.push(agent);
              }
            }
          }
        }
        if (list.length) {
          agents = [...agents, ...list];
        }
      }

      for (const collectives_id of need.collectives) {
          let list = [];
          for (let agent of streamAgents) {
              if (Array.isArray(agent.collectives)) {
                  if (agent.collectives.find(collectives => collectives === collectives_id)) {
                      if (!agents.find(el => el.id === agent.id)) {
                          list.push(agent);
                      }
                  }
              }
          }
          if (list.length) {
              agents = [...agents, ...list];
          }
      }

      // agents = agents.filter((agent) => {
      //   // count відображає тільки retention_file_opening і agent
      //   // amount всіх крім retention_file_opening і agent
      //   if (this.target_type === 'Count' && (agent.role === 'retention_file_opening' || agent.role === 'agent')) {
      //     return true;
      //   } else if (this.target_type === 'Amount' && agent.role !== 'retention_file_opening' && agent.role !== 'agent') {
      //     return true
      //   }
      //   return false;
      // });

      return agents || [];
    },

    getElemsForCalc() {
      const value = this.settings.value;
      if (
        !value.selected_agents?.length &&
        !value.selected_roles?.length &&
        value.selected_shifts?.length
      ) {
        // if only shifts
        return this.selectedShifts;
      }
      // all
      return this.selectedAgents;
    },

    perShift() {
      return this.getPerShift(this.settings.value.selected_shift)
    },

    useNetCount() {
      return this.settings.value.use_net_amount ? 'net_count' : 'count'
    },
  },
  methods: {
    title(title) {
        if (this.settings.value.show_title_block) {
            return this.settings.value.show_title_block
        }

        return title || '';
    },

    getPerShift(selected_shift) {
      const allShifts = this.streams.streams.statistic.shifts || [];
      let shift = allShifts.find(el => el.id === selected_shift);
      // if (
      //     (this.boardType === "retention_sales" && this.target_type === 'Count') ||
      //     ((this.boardType === "retention_fo_sales" || this.boardType === 'sales') && this.target_type === 'Amount')
      // ) {
      //   shift = {
      //     agents: [],
      //     daily: {count: 0, days: {remaining: 0, working: 0}, goal: 0, gross_sale: 0, net_sale: 0},
      //     id: -1,
      //     last_sale: null,
      //     monthly: {count: 0, days: {remaining: 0, working: 0}, goal: 0, gross_sale: 0, net_sale: 0},
      //     name: `${shift?.name || ''} (wrong target type)`,
      //     weekly: {count: 0, days: {remaining: 0, working: 0}, goal: 0, gross_sale: 0, net_sale: 0},
      //   }
      // }
      return shift;
    },

    getIconByShift(id) {
      const icon = this.streams.streams.statistic.shifts.find(item => item.id == id);
      return icon ? icon.icon : null;
      // return _.get(_.find(this.streams.streams.shifts, (item) => {
      //   return item.id == id;
      // }), ['icon'], null);
    },

    useByPaymentCapacity(part) {
      const capacity = this.settings.value.payment_capacity;

      if (capacity === PaymentCapacityTypes.full) {
          return `${part}_full`;
      }

      if (capacity === PaymentCapacityTypes.partial) {
          return `${part}_partial`;
      }

      return part;
    },

    useNetAmount(part = null) {
      if (!part) {
        return this.settings.value.use_net_amount ? 'net_sale' : 'gross_sale';
      }
      return this.settings.value.use_net_amount ? 'net_' + part + '_sale' : 'gross_' + part + '_sale';
    },
  },
  mounted() {
    switch (this.$options._componentTag) {
      case 'agent_list':
        this.scrollAllow = 1;
        break;
      case 'product_statistic':
        this.scrollAllow = 1;
        break;
      default:
        this.scrollAllow = 0;
        break;
    }
  },
}
